import { useTheme } from '@fluentui/react';
import { EMergeVMStatus } from 'global/Compare/ComparisonViewModelGenerator';
import React, { useMemo } from 'react';

interface IFieldMergePickerProps {
    mergeAction?: EMergeVMStatus;
    onMergeActionChange: (mergeAction: EMergeVMStatus) => void;
    disabled?: boolean;
}

const ARROW_STYLE: React.CSSProperties = {
    width: '0',
    display: 'inline-block',
    position: 'relative',
    left: '-15px',
};

const CONTAINER_STYLE: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
};

const BUTTON_STYLE: React.CSSProperties = {
    border: '1px solid #000000',
    width: '70px',
    fontSize: '11px',
    padding: '4px',
    cursor: 'pointer',
}

const DISABLED_BUTTON_STYLE: React.CSSProperties = {
    opacity: 0.55,
    cursor: 'not-allowed',
};

const LEFT_BUTTON_STYLE: React.CSSProperties = {
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
};

const RIGHT_BUTTON_STYLE: React.CSSProperties = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    marginLeft: '-1px',
};

const FieldMergePicker: React.FC<IFieldMergePickerProps> = (props) => {

    const theme = useTheme();

    const selectedStyle: React.CSSProperties = useMemo(() => ({
        ...BUTTON_STYLE,
        backgroundColor: theme.palette.themePrimary,
        color: theme.palette.white,
        ...(props.disabled ? DISABLED_BUTTON_STYLE : {}),
    }), [theme, props.disabled]);

    const regularStyle: React.CSSProperties = useMemo(() => ({
        ...BUTTON_STYLE,
        backgroundColor: theme.palette.neutralLighter,
        color: theme.palette.neutralPrimary,
        ...(props.disabled ? DISABLED_BUTTON_STYLE : {}),
    }), [theme, props.disabled]);

    const isOriginSelected = props.mergeAction === EMergeVMStatus.UseOrigin;

    const isTargetSelected = props.mergeAction === EMergeVMStatus.UseTarget;

    return (
        <div style={CONTAINER_STYLE}>
            <button
                onClick={(event) => {
                    event.stopPropagation();
                    props.onMergeActionChange(EMergeVMStatus.UseOrigin)
                }}
                style={{
                    ...(isOriginSelected ? selectedStyle : regularStyle),
                    ...LEFT_BUTTON_STYLE,
                }}
                className={'toggle-option ' + (isOriginSelected ? 'selected' : undefined)}
                disabled={props.disabled}
            >
                <span style={ARROW_STYLE}>
                    {isOriginSelected ? '➤' : undefined}
                </span>
                <span>
                    Origin
                </span>
            </button>
            <button
                onClick={(event) => {
                    event.stopPropagation();
                    props.onMergeActionChange(EMergeVMStatus.UseTarget)
                }}
                style={{
                    ...(isTargetSelected ? selectedStyle : regularStyle),
                    ...RIGHT_BUTTON_STYLE,
                }}
                className={'toggle-option ' + (isTargetSelected ? 'selected' : undefined)}
                disabled={props.disabled}
            >
                <span style={ARROW_STYLE}>
                    {isTargetSelected ? '➤' : undefined}
                </span>
                <span >
                    Target
                </span>
            </button>
        </div>
    );
};

export default FieldMergePicker;